import React from "@platform/react";
import { Sequential } from "@platform/utils/dist/uuid";

import { Component } from "@platform/react-storybook/Component";
import { Button } from "@front/components/Element/Button";
import { Box } from "@front/components/Element/Box";
import { Text } from "@front/components/Element/Text";

import { IconAsset } from "@front/components/Element/Asset/Icon";

import Rules from "./_rules.module.scss";
import type { PropTypesAssessment } from "./types";
import { DEF_ASSESSMENT, NAME_ASSESSMENT, TYPE_ASSESSMENT } from "./types";

export function SectionAssessment(props: PropTypesAssessment) {
    const { onClick, comments, ...rest } = props;
    return (
        <Component {...rest} name={NAME_ASSESSMENT} tag="div" type={TYPE_ASSESSMENT}>
            <header>
                <Text preset="torreon" uuid="title-reviews" />
            </header>
            <footer>
                <div>
                    {comments.map(({ comment, userComment, featuredMessage, rating }) => {
                        const start = Array(rating).fill(
                            <IconAsset fill="cuba" uuid="fill-star" />,
                        );
                        return (
                            <Box key={Sequential()} locked={false} preset="vulpix">
                                <Text className={Rules.user} preset="osorno" uuid={userComment} />
                                <Text
                                    className={Rules.cardContent}
                                    preset="paine"
                                    uuid={featuredMessage}
                                />
                                <Text className={Rules.cardContent} preset="angol" uuid={comment} />
                                <span className={Rules.start}>{start}</span>
                            </Box>
                        );
                    })}
                </div>
                <Button disabled preset="nigeria" text="button-reviews" onClick={onClick} />
            </footer>
        </Component>
    );
}
SectionAssessment.defaultProps = DEF_ASSESSMENT;
